import React from "react";
import "./css/d2.css";

export default function MenuTemplate2({ menu, categories }) {
  if (!menu || !categories) return <p>Loading…</p>;

  const colors = menu.colors || {
    primary: "#2e7d32",
    background: "#fafafa",
    text: "#222",
    card: "#ffffff",
  };

  return (
    <div
      className="t2-container"
      style={{ backgroundColor: colors.background, color: colors.text }}
    >
      {/* HEADER IMAGE */}
      {menu.imageUrl && (
        <div className="t2-headerWrapper">
          <img src={menu.imageUrl} alt="header" className="t2-headerImage" />
          <div className="t2-headerOverlay"></div>
          <div className="t2-headerText">
            <h1>{menu.name}</h1>
            {menu.tagline && <p>{menu.tagline}</p>}
          </div>
        </div>
      )}

      <div className="t2-content">
        {categories.map((cat) => (
          <section key={cat.id} className="t2-category-block">
            <h2
              className="t2-category-title"
              style={{ borderColor: colors.primary }}
            >
              {cat.name}
            </h2>

            {cat.items.length === 0 && (
              <p className="t2-empty">No items available</p>
            )}

            <div className="t2-vertical-list">
              {cat.items.map((item) => (
                <div key={item.id} className="t2-item-vertical">
                  {/* IMAGE ON LEFT */}
                  {item.imageUrl && (
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      className="t2-item-vertical-img"
                    />
                  )}

                  <div className="t2-item-vertical-info">
                    <h3>{item.name}</h3>
                    {item.description && (
                      <p className="t2-item-vertical-desc">
                        {item.description}
                      </p>
                    )}
                  </div>

                  <span
                    className="t2-item-vertical-price"
                    style={{ color: colors.primary }}
                  >
                    ${parseFloat(item.price).toFixed(2)}
                  </span>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
